import { createAction } from '@ngrx/store';


export const resetDashBoardState=createAction(
    "[Dashboard state reseted] reset dashboard state",
)
